export default __webpack_public_path__ + "images/0xee9ff3efd508741492b5bd45269aa45a43be59c8.png";